var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.editor
    ? _c(
        "div",
        {
          staticClass:
            "tiptap-toolbar d-flex flex-wrap gap-1 align-items-center p-1 border-bottom rounded rounded-bottom-0",
          class: { "bg-light": !_setup.isDarkMode },
          attrs: { role: "toolbar", "aria-label": "Tiptap editor toolbar" },
          on: {
            mousedown: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "btn-group btn-group-sm pe-1 border-end rounded-0",
              attrs: { role: "group" },
            },
            [
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-type-bold",
                  command: _vm.editor.commands.toggleBold,
                  "is-active": _vm.editor.isActive("bold"),
                  title: "Bold (" + _setup.modKey + " B)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-type-italic",
                  command: _vm.editor.commands.toggleItalic,
                  "is-active": _vm.editor.isActive("italic"),
                  title: "Italic (" + _setup.modKey + " I)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-type-strikethrough",
                  command: _vm.editor.commands.toggleStrike,
                  "is-active": _vm.editor.isActive("strike"),
                  title:
                    "Strikethrough (" +
                    _setup.modKey +
                    " " +
                    _setup.shiftKey +
                    " S)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-eraser",
                  command: _vm.editor.commands.unsetAllMarks,
                  title: "Remove styling",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-group btn-group-sm pe-1 border-end rounded-0",
              attrs: { role: "group" },
            },
            [
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-text-left",
                  command: () => _setup.setTextAlign("left"),
                  "is-active": _vm.editor.isActive({ textAlign: "left" }),
                  title:
                    "Align left (" +
                    _setup.modKey +
                    " " +
                    _setup.shiftKey +
                    " L)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-text-center",
                  command: () => _setup.setTextAlign("center"),
                  "is-active": _vm.editor.isActive({ textAlign: "center" }),
                  title:
                    "Align center (" +
                    _setup.modKey +
                    " " +
                    _setup.shiftKey +
                    " E)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-text-right",
                  command: () => _setup.setTextAlign("right"),
                  "is-active": _vm.editor.isActive({ textAlign: "right" }),
                  title:
                    "Align right (" +
                    _setup.modKey +
                    " " +
                    _setup.shiftKey +
                    " R)",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-group btn-group-sm pe-1 border-end rounded-0",
              attrs: { role: "group" },
            },
            [
              _c(_setup.TiptapToolbarImage, {
                attrs: { editor: _vm.editor, title: "Image" },
                on: {
                  "open-image-modal": function ($event) {
                    return _vm.$emit("open-image-modal")
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-hr",
                  command: _vm.editor.commands.setHorizontalRule,
                  title: "Horizontal rule (---)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-list-ol",
                  command: _vm.editor.commands.toggleOrderedList,
                  "is-active": _vm.editor.isActive("orderedList"),
                  title:
                    "Ordered list (" +
                    _setup.modKey +
                    " " +
                    _setup.shiftKey +
                    " 7)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-list-ul",
                  command: _vm.editor.commands.toggleBulletList,
                  "is-active": _vm.editor.isActive("bulletList"),
                  title:
                    "Bulleted list (" +
                    _setup.modKey +
                    " " +
                    _setup.shiftKey +
                    " 8)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-blockquote-left",
                  command: _vm.editor.commands.toggleBlockquote,
                  "is-active": _vm.editor.isActive("blockquote"),
                  title: "Blockquote (>)",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-group btn-group-sm pe-1 border-end rounded-0",
              attrs: { role: "group" },
            },
            [
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-link",
                  command: _setup.setLink,
                  "is-active":
                    _vm.editor.isActive("link") &&
                    !_setup.isPidLink &&
                    !_setup.isDidLink,
                  title: "Link (" + _setup.modKey + " K)",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarPageLink, {
                attrs: {
                  editor: _vm.editor,
                  "is-pid-link": _setup.isPidLink,
                  title: "Page link",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarDocumentLink, {
                attrs: {
                  editor: _vm.editor,
                  "is-did-link": _setup.isDidLink,
                  title: "Document link",
                },
              }),
              _vm._v(" "),
              _c(
                _setup.TiptapToolbarBtn,
                {
                  attrs: {
                    command: _vm.editor.commands.unsetLink,
                    disabled: !_vm.editor.isActive("link"),
                    title: "Unset link",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        position: "relative",
                        display: "inline-block",
                      },
                    },
                    [
                      _c("i", { staticClass: "bi bi-link" }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "bi bi-slash-lg",
                        staticStyle: {
                          position: "absolute",
                          left: "0",
                          top: "0",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(_setup.TiptapToolbarBlockMenu, { attrs: { editor: _vm.editor } }),
          _vm._v(" "),
          _c(_setup.TiptapToolbarStylesMenu, { attrs: { editor: _vm.editor } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-group btn-group-sm ps-1 border-start rounded-0",
              attrs: { role: "group" },
            },
            [
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-clipboard-x",
                  command: () => {
                    _vm.$emit(
                      "update:pasteAsPlainTextActive",
                      !_vm.pasteAsPlainTextActive
                    )
                  },
                  "is-active": _vm.pasteAsPlainTextActive,
                  title: "Toggle Paste as Plain Text",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: _vm.isFullScreen
                    ? "bi-fullscreen-exit"
                    : "bi-fullscreen",
                  command: _setup.toggleFullScreen,
                  "is-active": _vm.isFullScreen,
                  title: "Full screen",
                },
              }),
              _vm._v(" "),
              _c(_setup.TiptapToolbarBtn, {
                attrs: {
                  iconClass: "bi-code-slash",
                  command: _setup.toggleSourceMode,
                  "is-active": _vm.isSourceMode,
                  title: "Source mode",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }